import React from 'react';
import { useEffect, useState, useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './stepone.component.css';
import { getStockPriceOnDate, searchCompany } from '../../../../api';
import { Form, Alert } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import moment from 'moment';
import DatePickerCustomized from './date_picker_customized/date_picker_customized.component';
import SearchBar from './search_bar/search_bar.component';

const StepOneMob = (props) => {
  // Inline edit

  // Form elements
  const [company_name, set_company_name] = useState('');
  const [comp_id, set_comp_id] = useState();
  const [fincode, set_fincode] = useState(null);
  const [type, set_type] = useState('');
  const [shares, set_shares] = useState('');
  const [date_obj, set_date_obj] = useState(null);
  const [date, set_date] = useState('');
  const [price, set_price] = useState('');
  const [cost_value, set_cost_value] = useState(0);
  const [inception_date, set_inception_date] = useState('');

  const containerRef = useRef(null);
  const isFirstRender = useRef(true);

  // Search functionality
  const clearComp = () => {
    set_company_name();
    set_comp_id();
    set_inception_date('');
  };

  const onSearchClick = (c) => {
    set_comp_id(c.id);
    set_company_name(c.short_name);
    set_fincode(c.fincode);
    if (moment(c.data_inception_date).isValid()) {
      set_inception_date(c.data_inception_date);
      const inceptionDateObj = new Date(c.data_inception_date);
      if (date_obj && date_obj < inceptionDateObj) {
        set_date_obj(inceptionDateObj);
        set_date(moment(inceptionDateObj).format('DD-MM-YYYY'));
      }
      return;
    }
    set_inception_date('');
  };

  // Form functions
  const positive_num = (v) => typeof v === 'number' && v > 0;
  const date_str = (v) => moment(v, 'D-M-YYYY', true).isValid();

  // Check is a value is valid based on a checker function(if provided)
  const isValid = ([val, checker]) => {
    if (val && val !== undefined && val !== '') {
      if (checker) return checker(val);
      return true;
    }
    return false;
  };

  const clearForm = () => {
    set_comp_id();
    set_fincode(null);
    set_company_name('');
    set_type('');
    set_shares('');
    set_date('');
    set_date_obj(null);
    set_price('');
    set_cost_value(0);
    set_inception_date('');
  };

  const checkForm = () => {
    const values = [comp_id, company_name, type, shares, date, price, date_obj];
    const validators = [
      null,
      null,
      null,
      positive_num,
      date_str,
      positive_num,
      null,
    ];
    const validations = values.map((v, i) => [v, validators[i]]);
    return validations.every(isValid);
  };

  // Check transaction validity and add if its valid
  const checkAndAdd = () => {
    if (checkForm()) {
      const tx = {
        company_id: comp_id,
        company_name,
        type,
        shares,
        date,
        date_obj,
        price,
        cost_value: cost_value,
        data_inception_date: inception_date,
        fincode,
      };
      props.setTxs([tx]);
    }
  };

  const get_and_set_price = async (on_date) => {
    if (!fincode || !on_date) return;
    const res = await getStockPriceOnDate(fincode, on_date);
    const stock_price = res.data.data.value;
    set_price(stock_price);
  };

  useEffect(() => {
    if (!price || !shares) {
      set_cost_value('');
      return;
    }
    if (typeof shares === 'number' && typeof price === 'number')
      set_cost_value((price * shares).toFixed(2));
  }, [price, shares]);

  useEffect(() => {
    if (date_obj) {
      get_and_set_price(moment(date_obj).format('DDMMYYYY'));
    }
  }, [fincode, date_obj]);

  const getTypeClass = () => {
    let className = 'type-select add-tx-mobile-inputs';
    if (type === '') {
      return className + ' placeholder';
    }
    return className;
  };

  useEffect(() => {
    if (props.txs.length) {
      const {
        company_id,
        company_name,
        type,
        shares,
        date,
        price,
        date_obj,
        data_inception_date,
      } = props.txs[0];
      set_comp_id(company_id);
      set_company_name(company_name);
      set_type(type);
      set_shares(shares);
      set_date(date);
      set_price(price);
      set_date_obj(date_obj);
      set_inception_date(data_inception_date);
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      if (props.txs.length && !company_name) {
        props.setTxs([]);
        clearForm();
      }
      checkAndAdd();
    }
  }, [company_name, type, shares, date, price, cost_value]);

  const handleDateRawChange = (e, minDate) => {
    let dateStr = e.target.value;
    if (moment(dateStr, 'D-M-YYYY', true).isValid()) {
      dateStr = dateStr.split('-').reverse().join('-');
      let date_obj = new Date(dateStr);
      if (date_obj > new Date()) {
        date_obj = new Date();
      }
      if (minDate && date_obj < minDate) {
        date_obj = minDate;
      }
      set_date_obj(date_obj);
      set_date(moment(date_obj).format('DD-MM-YYYY'));
    }
  };

  return (
    <div ref={containerRef} className="p-4">
      <div id="calendar-portal"></div>
      <div className="add-tx-header">
        <span className="step-text">{props.pfName}</span>
        <h5 className="step-heading pt-1">ADD AN INVESTMENT</h5>
        <span className="step-info">
          Please enter unadjusted amount, we will adjust for bonus and splits in
          the next step
        </span>
      </div>
      <section className="add-tx-mobile mt-3 p-0">
        <div>
          <label>Company name</label>
          {(!comp_id && !props.txs[0] && (
            <div className="position-relative">
              <SearchBar
                placeholder="+ Add a company"
                onSearchClick={onSearchClick}
                suggestionsPosition={{ position: 'absolute', top: '31px' }}
                inputClass="w-100 border-0"
                containerClass="add-tx-mobile-inputs"
              />
            </div>
          )) || (
            <div className="comp-name" onClick={(e) => clearComp()}>
              {props.txs[0] ? props.txs[0].company_name : company_name}
              <span>
                &nbsp;
                <X color="#BFBFBF" />
              </span>
            </div>
          )}
        </div>
        <div className="input__container">
          <div className="tx_type__container">
            <label>Transaction Type</label>
            <div>
              <Form.Control
                className={getTypeClass()}
                as="select"
                value={props.txs[0] ? props.txs[0].type : type}
                onChange={(e) => {
                  set_type(e.target.value);
                }}
              >
                <optgroup>
                  <option disabled value="">
                    Transaction Type
                  </option>
                  <option value="BUY">Buy</option>
                  <option value="SELL">Sell</option>
                </optgroup>
              </Form.Control>
            </div>
          </div>
          <div className="">
            <label>Shares</label>
            <div className="add-tx-mobile-inputs">
              <input
                className="border-0 w-100"
                type="number"
                min={0}
                value={props.txs[0] ? props.txs[0].shares : shares}
                placeholder="Shares"
                onChange={(e) => {
                  set_shares(e.target.value ? parseInt(e.target.value) : '');
                }}
              ></input>
            </div>
          </div>
        </div>
        <div className="input__container">
          <div className="">
            <label>Date</label>
            <div className="add-tx-mobile-inputs">
              <DatePickerCustomized
                selected={date_obj}
                onSelect={(d) => {
                  set_date_obj(d);
                  set_date(moment(d).format('DD-MM-YYYY'));
                }}
                onChangeRaw={handleDateRawChange}
                type={type}
                minDate={inception_date}
                isDisabled={!comp_id}
                inputClass="w-100"
              />
            </div>
          </div>
          <div className="">
            <label>Share price</label>
            <div className="add-tx-mobile-inputs">
              <input
                className="border-0 w-100"
                min={0}
                type="number"
                step="0.01"
                placeholder="Share price"
                value={props.txs[0] ? props.txs[0].price : price}
                onChange={(e) => {
                  set_price(parseFloat(e.target.value));
                }}
              ></input>
            </div>
          </div>
        </div>
        <div className="w-100">
          <label>Amount</label>
          <div className="add-tx-mobile-inputs cost_value">
            {props.txs[0] ? props.txs[0].cost_value : cost_value}
          </div>
        </div>
        {props.invalidComps.length > 0 && (
          <Alert variant="danger" className="sell-tx-error">
            Invalid sell transaction: You do not have enough shares.
          </Alert>
        )}
      </section>
    </div>
  );
};

export default StepOneMob;
